<template>
  <div :class="`w-full max-w-1140 mx-auto px-6 ${fullContainerClass}`">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  fullContainerClass: {
    type: String,
    default: "",
  },
});
</script>
